import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { contentDate } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../service/wp-blogs-store'
import LazyYouTubeEmbed from '@/commons/LazyYouTubeEmbed'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-01-31'

export async function getStaticProps() {

    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

  return {
      props: {
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>Zumba Classes in Singapore - The Trending Fitness Mantra!</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Looking for Zumba classes in Singapore? Zumba is one of the most popular exercises in the form of Latin dance which was introduced by Zumba organization."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/zumba-classes-in-singapore" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content="Zumba Classes in Singapore - The Trending Fitness Mantra!"/>
        <meta property="og:description" content="Looking for Zumba classes in Singapore? Zumba is one of the most popular exercises in the form of Latin dance which was introduced by Zumba organization." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-09T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/zumba-trainer.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/zumba-trainer.webp" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/zumba-classes-in-singapore"/>
        <meta name="twitter:title" content="Zumba Classes in Singapore - The Trending Fitness Mantra!"/> 
        <meta name="twitter:description" content="Looking for Zumba classes in Singapore? Zumba is one of the most popular exercises in the form of Latin dance which was introduced by Zumba organization."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/zumba-classes-in-singapore" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@type":"BreadcrumbList","@id":"https://www.stringssg.com/blogs/zumba-classes-in-singapore/#breadcrumblist","itemListElement":[{"@type":"ListItem","@id":"https://www.stringssg.com/#listItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"},"nextItem":"https://www.stringssg.com/blogs/#listItem"},{"@type":"ListItem","@id":"https://www.stringssg.com/blogs/#listItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/","name":"blogs","url":"https://www.stringssg.com/blogs/"},"previousItem":"https://www.stringssg.com/#listItem","nextItem":"https://www.stringssg.com/blogs/zumba-classes-in-singapore/#listItem"},{"@type":"ListItem","@id":"https://www.stringssg.com/blogs/zumba-classes-in-singapore/#listItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/zumba-classes-in-singapore/","name":"zumba","description":"Looking for Zumba classes in Singapore? Zumba is one of the most popular exercises in the form of Latin dance which was introduced by Zumba organization.","url":"https://www.stringssg.com/blogs/zumba-classes-in-singapore/"},"previousItem":"https://www.stringssg.com/blogs/#listItem"}]},{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG Singapore","url":"https://www.stringssg.com/"},{"@type":"WebSite","@id":"https://www.stringssg.com/#website","url":"https://www.stringssg.com/","name":"StringsSG Singapore","inLanguage":"en-US","publisher":{"@id":"https://www.stringssg.com/#organization"}},{"@type":"VideoObject","@id":"https://www.stringssg.com/blogs/zumba-classes-in-singapore/#video","name":"Zumba Classes in Singapore - The Trending Fitness Mantra!","description":"Watch this video to try a 30 mins Zumba class at home!","thumbnailUrl":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/zumba-trainer.webp"],"uploadDate":"2022-05-03T08:00:00+08:00","duration":"PT29M43S","contentUrl":"https://youtu.be/mZeFvX3ALKY","embedUrl":"https://www.youtube.com/embed/mZeFvX3ALKY","interactionStatistic":{"@type":"InteractionCounter","interactionType":{"@type":"WatchAction"},"userInteractionCount":5647018}},{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/zumba-classes-in-singapore/#webpage","url":"https://www.stringssg.com/blogs/zumba-classes-in-singapore","name":"Zumba Classes in Singapore - The Trending Fitness Mantra!","description":"Looking for Zumba classes in Singapore? Zumba is one of the most popular exercises in the form of Latin dance which was introduced by Zumba organization.","inLanguage":"en-US","isPartOf":{"@id":"https://www.stringssg.com/#website"},"breadcrumb":{"@id":"https://www.stringssg.com/blogs/zumba-classes-in-singapore/#breadcrumblist"},"video":{"@id":"https://www.stringssg.com/blogs/zumba-classes-in-singapore/#video"},"datePublished":"2025-01-09T07:30:46+00:00","dateModified":"2022-11-10T21:22:19+08:00"}]}`
          }}
        />
      </Head>
      <div className='max-w-5xl mx-auto py-5 px-2'>
            <div className='space-y-2'>
                <h1 className='text-xl md:text-2xl font-semibold uppercase'>Zumba Classes in Singapore - The Trending Fitness Mantra!</h1>
                <div className='text-gray-400 text-xs'>
                <time dateTime={modifiedDate}>{new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                </div>
            </div>
            <div className='py-2 text-gray-500 leading-8 space-y-2'>
                <div className='py-2 space-y-2'>
                    <h3 className='font-bold'>What is Zumba?</h3>
                    <p>
                        Zumba is one of the most popular exercises in the form of Latin dance which was introduced by 
                        <a href="https://www.zumba.com/en-US/" target="_blank" rel="noreferrer nofollow noopener" className='text-orange-600'> Zumba organization
                        </a>
                        . There has been a steady increase in the
                        number of Singapore residents who have shown interest in this fitness program.
                    </p>
                    <p>
                        The demand for Zumba in Singapore started rising since the early 2010.
                    </p>
                    <div className='relative h-96 max-full my-5'>
                        <Image className='rounded-lg'
                            src={s3Static + "blog/health+and+fitness/zumba-trainer.webp"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='BodyCombat Singapore'
                        />          
                    </div>
                </div>
                <div className='pt-5 space-y-2'>
                    <h2 className='text-xl md:text-2xl text-center font-bold'>
                        Popular Instructors for Zumba Classes in Singapore
                    </h2>
                </div>
                <div className='space-y-2 py-5'>
                    <h3 className='font-bold pt-5 text-lg'>
                        1. Lynn Ang
                    </h3>
                    <p>                     
                        A mother of 3 children, Lynn strongly believes that an active lifestyle is the key to a healthy body and happy demeanor. She is passionate about 
                        “infecting” her students with the exercise “bug”, and providing them with a safe and enjoyable workout that helps them reach their fitness goals.
                    </p>   
                    <div className='relative h-96 max-w-xl'>
                        <Image className=''
                            src={s3Static + "blog/health+and+fitness/lynn.webp"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'left'}}   
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Lynn Ang - StringsSG'
                        />          
                    </div>
                    <p> 
                        <strong>♣ Dance Background</strong>
                        <br/>
                        Lynn developed a love for music and dancing since young, and it has never stopped, even after she joined the workforce. She is trained in Standard Latin Dance, 
                        Jazz Dance, Chinese dance, and has experience in other dance forms like Tap dance, Malay dance, Modern dance, Ballroom Waltz, etc.. During her university days, 
                        she was part of the dance crew in her Hall of Residence, and they performed, as well as won accolades in numerous dance competitions. She attributes her ear for 
                        rhythms and melodies to her classical music training, having obtained a Diploma in Piano Performance (LTCL) and achieved ABRSM Grade 8 (Distinction).
                    </p>
                    <p> 
                        <strong>♣ Fitness Background</strong>
                        <br/>
                        Lynn has always been active in sports since her school days, and competed in Track and Field on a national level. She has more than 20 years of practical 
                        weight-training and fitness training experience. Lynn is certified instructor for Zumba, Strong by Zumba, Zumba Kids/ Jr, BollyDazz and Piloxing SSP.
                    </p>
                    <p> 
                        <strong>♣ Training Background</strong>
                        <br/>
                        Fitness group training is a natural progression for Lynn, as she has conducted corporate training since 1997 (ranging from 1-to-1 coaching to seminars of more 
                        than 500 persons). She is also a WDA-certified trainer for Adult Education, holding the Advanced Certificate in Training and Assessment (ACTA), and ITE Coaching 
                        Certificate, amongst other training-related certifications.
                    </p>    
                    <p>
                        Come shake your booty with Lynn!
                    </p>            
                    <p>
                        Contact Profile - 
                        <Link href="/profile/lynn-ang-1526" prefetch={false} className='text-orange-600'> https://www.stringssg.com/profile/lynn-ang-1526</Link>
                    </p>
                    <h3 className='font-bold pt-5 text-lg'>
                        2. Wendy Wong
                    </h3>
                    <div className='relative h-96 max-w-xl'>
                        <Image className=''
                            src={s3Static + "blog/health+and+fitness/wendy.webp"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'left'}}    
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Wendy Wong - StringsSG'
                        />          
                    </div>
                    <p> 
                        Now running my own executive coaching , HR consulting and fitness business. A certified Zumba fitness and a Strong By Zumba Instructor, teaching since 2016.  
                        Strong passion and belief that health and fitness is so important (I don’t mean we have to carve out a bodybuilder physique). With a proper coaching with me, anyone 
                        (kids, teenagers, adults ) can improve his/her fitness according to individual’s expectation.
                    </p> 
                    <p> 
                        I look forward to having a fun and smiley time with you on your fitness journey. 😀     
                    </p>                    
                    <p>
                        Contact Profile - 
                        <Link href="/profile/wendy-wong-3966" prefetch={false} className='text-orange-600'> https://www.stringssg.com/profile/wendy-wong-3966</Link>
                    </p> 
                    <h3 className='font-bold pt-5 text-lg'>
                        3. Jeffrey Lim
                    </h3>
                    <p>
                        Fitness Instructor, Personal Trainer and Choreographer.
                    </p>
                    <div className='relative h-96 max-w-md flex'>
                        <Image className=''
                            src={s3Static + "blog/health+and+fitness/jeffrey.webp"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'left'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Jeffrey Lim - StringsSG'
                        />          
                    </div>
                    <p>
                        - 6 years of experience in fitness instruction
                        <br/>
                        - BSocSc, Psychology, SMU, Singapore
                        <br/>
                        - American Council on Exercise Certified Personal Trainer
                        <br/>
                        - FISAF International Certified Group Exercise Instructor
                        <br/>
                        - PILOXING Master Trainer Singapore (2016)
                        <br/>
                        - Zumba Fitness Instructor
                        <br/>
                        - WAKO Kickboxing Trainer
                        <br/>
                        - NCAP Level 2
                        <br/>
                        - First Aid, CPR/AED Certified
                    </p>                    
                    <p>
                        Contact Profile - 
                        <Link href="/profile/jeffrey-lim-1095" prefetch={false} className='text-orange-600'> https://www.stringssg.com/profile/jeffrey-lim-1095</Link>
                    </p>                    
                </div>
                <div>
                    <h3 className='font-bold pt-2'>Is Zumba classes good for weight loss?</h3>
                    <p>
                        Zumba fitness works by combining a mixture of low intensity and high intensity interval moves in the form highly energetic Latin dance forms. 
                        The Zumba classes require you to constantly keep moving by following the steps of the instructor, which involves the movement of every muscle group,
                        which in turn triggers weight loss. When done at least 3 to 5 times a week along with proper diet, you would see noticeable difference in body weight within a month.    
                    </p>
                    <h3 className='font-bold pt-2'>How many calories can I burn in a Zumba class?</h3>
                    <p>
                        When done with proper moves you can burn in between 500 to 900 calories in a one-hour class.    
                    </p>
                    <h3 className='font-bold pt-2'>Who conducts Zumba classes?</h3>
                    <p>
                        A Zumba class can be conducted by certified Zumba trainers who go through a training program to learn the various forms and steps involved in a Zumba class.
                    </p>                    
                </div>
                <div className='pt-5 space-y-2 text-center'>
                    <h2 className='text-xl md:text-2xl font-bold uppercase'>
                        Top 3 Benefits of Zumba Classes
                    </h2>
                </div>
                <div className='py-2 space-y-2'>
                    <h3 className='font-bold'>
                        1. Improves the cardiovascular fitness
                    </h3>
                    <p>
                        Zumba keeps your heart rate higher throughout the class, which strength the heart functioning, hence improves the cardiovascular functions of our body.
                    </p>
                    <h3 className='font-bold pt-2'>
                        2. Helps in weight loss
                    </h3>
                    <p>
                        Zumba is a high intensity workout which can burn in between 500 to 900 calories in a one-hour class, resulting in weight loss.
                    </p>
                    <h3 className='font-bold pt-2'>
                        3. Helps to tone the muscles
                    </h3>
                    <p>
                        Zumba classes in Singapore are pretty intense and would require intense motion of all muscle groups of your body, which helps in overall toning of your body.
                    </p>
                </div>
                <div className='pt-5 space-y-2 text-center'>
                    <h2 className='text-xl md:text-2xl font-bold uppercase'>
                        Who should not do Zumba!
                    </h2>
                </div>
                <div className='py-2 space-y-2'>
                    <h3 className='font-bold'>
                        1. If you have a heart condition
                    </h3>
                    <p>
                        Zumba classes can get intense and requires your heart beat faster. If you have an existing heart condition then stay away from Zumba.
                        Call helpline 995, if you feel dizzy, have difficulty breathing or get a chest pain during the class.
                    </p>
                    <h3 className='font-bold pt-2'>
                        2. Someone with bone and joint problems
                    </h3>
                    <p>
                        Zumba is not for you if you have chronic bone and joint inflammations.
                    </p>
                </div>
                
                <div className='py-10 text-center'>
                    <Link href="/sg/personal-trainer" className='px-3 py-3 border border-amber-600 text-orange-600 rounded-lg'>
                            Get a Zumba Instructor
                    </Link>
                    <h3 className='text-center font-bold text-lg text-gray-500 pt-10 px-2'>Watch this video to try a 30 mins Zumba class at home!</h3>
                    <LazyYouTubeEmbed videoId="mZeFvX3ALKY" title="Watch this video to try a 30 mins Zumba class at home!" />
                </div>
            </div>
            <h2 className='text-center text-xl uppercase'>You may also like</h2>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
        <BlogHeaderLinks/>
        <Script 
            id="google-tagmanager-new"
            src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
            strategy="lazyOnload"
            onLoad={() => {              
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
            
                gtag('config', 'G-QD1HGGHDYJ');
            }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}